module.exports = __webpack_public_path__ + "static/media/6_r_sobaka_77.45_75.56.dce343f8.png";